import { useQuery } from '@tanstack/react-query';
import assistantService from '@services/assistant';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import { getAssistantErrorCode } from './assistantErrorMessage';

export const ASSISTANT_CONVERSATION_QUERY_KEY = 'assistantConversation';

/** `refetchInterval` polls every 2s exactly while `status === 'THINKING'`, copied from
 * `useProjectPlanDraft.ts`'s polling pattern (see `docs/architecture.md`'s Sprint 32 section). */
export const useAssistantConversation = (conversationId?: string) => {
  const { organizationId } = useAppSelector((state: RootState) => state.organization);

  return useQuery({
    queryKey: [ASSISTANT_CONVERSATION_QUERY_KEY, organizationId, conversationId],
    queryFn: () => assistantService.getAssistantConversation(conversationId as string),
    enabled: !!conversationId,
    // An unknown/foreign id will never start working — do not spend three backoff retries on it.
    retry: (failureCount, error) => getAssistantErrorCode(error) !== 'ASSISTANT_NOT_FOUND' && failureCount < 2,
    refetchInterval: (query) => (query.state.data?.status === 'THINKING' ? 2000 : false),
  });
};

export default useAssistantConversation;
